import { ApolloError } from '@apollo/client';
import { ErrorCode } from 'generated/graphql';

const errorMessages = {
  [ErrorCode.UNAUTHENTICATED]: '로그인이 필요한 요청입니다.',
  [ErrorCode.NOT_FOUND]: '존재하지 않는 데이터 입니다.',
  [ErrorCode.FORBIDDEN]: '요청할 수 있는 권한이 없습니다.',
  [ErrorCode.UNKWON_ERROR]: '알 수 없는 에러로 인해 요청이 정상적으로 처리되지 않았습니다.',
};

function apolloErrorParser(error?: ApolloError) {
  const errorCode: ErrorCode = error?.graphQLErrors?.[0]?.extensions?.code || ErrorCode.UNKWON_ERROR;

  const errorMessage: string =
    error?.graphQLErrors?.[0]?.message || errorMessages[errorCode] || `${errorCode} 에러가 발생 하였습니다.`;

  return {
    errorCode,
    errorMessage,
  };
}

export default apolloErrorParser;
